import { render, staticRenderFns } from "./BoCustomerTreatementDatatable.vue?vue&type=template&id=422a684a&scoped=true"
import script from "./BoCustomerTreatementDatatable.vue?vue&type=script&lang=js"
export * from "./BoCustomerTreatementDatatable.vue?vue&type=script&lang=js"
import style0 from "./BoCustomerTreatementDatatable.vue?vue&type=style&index=0&id=422a684a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a684a",
  null
  
)

export default component.exports